import { defineEntitySource } from '@/shared/form/entity-source';

import type { CommunicationSettingOption } from './communication-setting.wire';

// Seletor de régua de comunicação para outros módulos (P06, porta F0): o autocomplete do legado,
// rótulo `({walletCode}) - {name}` e valor `id` (`communicationSettingContext.tsx:78-96`). Leve: o fio
// entra por `import()` na primeira busca.

const loadApi = () => import('./communication-setting.api');

/** `walletsCode` restringe ao convênio escolhido no formulário de quem usa (Cessionário, Parcelamento). */
export function communicationSettingSource(walletsCode?: () => string | number | null | undefined) {
  return defineEntitySource<CommunicationSettingOption>({
    key: ['communication-setting', 'options'],
    scope: () => walletsCode?.() ?? null,
    search: async (query, signal) => (await (await loadApi()).listCommunicationSettingOptions({ walletsCode: walletsCode?.(), searchString: query || undefined }, signal)).data,
    byId: async (id, signal) => (await loadApi()).getCommunicationSetting(id, signal),
    toOption: (item) => ({ value: item.id, label: `(${String(item.walletCode ?? '')}) - ${item.name}` }),
  });
}
